import React, { useState, useEffect, FC } from 'react'
import moment from 'moment-timezone'
import { Tooltip } from 'transfix-ui/components/Tooltip'

const getTime = (): string => {
  const now = moment()
  if (now) {
    return now.tz(moment.tz.guess())?.format('h:mm A z') || ''
  }
  return ''
}

const getNowLeftPosition = (): string => {
  const now = moment()
  const midnight = now.clone().startOf('day')
  const diffMinutes = now.diff(midnight, 'minutes')
  return `${(100 * diffMinutes) / (24 * 60)}%`
}

const useLeftPosition = () => {
  const [left, setLeft] = useState(getNowLeftPosition())
  useEffect(() => {
    const interval = setInterval(() => setLeft(getNowLeftPosition()), 1000)
    return () => clearInterval(interval)
  }, [])
  return left
}

export const NowHead: FC = () => {
  const left = useLeftPosition()
  return (
    <Tooltip position='bottom' trigger={<span className='calendar-now-head' style={{ left }} />}>
      {getTime()}
    </Tooltip>
  )
}

export const NowNeedle: FC = () => {
  const left = useLeftPosition()
  return <span className='calendar-now-needle' style={{ left }} />
}
